import React, { useEffect, useState } from "react";
import Table from "../shared/table/Table";
import { FiEdit3 } from "react-icons/fi";
import { useNavigate, useLocation } from "react-router-dom";
import { fetchData, fetchFormData } from "../../utils/options";
import { MdThumbDown, MdThumbUp } from "react-icons/md";
import topTost from "../../utils/topTost";

const UserHeirachyTable = ({ permission }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const M_id = queryParams.get("id");
  const userId = localStorage.getItem("id");
  const [data, setData] = useState([]);
  useEffect(() => {
    window.scrollTo(0, 0);
    if (localStorage.getItem("access_token") === null) {
      navigate("/");
    }
  }, []);

  const fetchtaskData = async () => {
    const formData = new FormData();
    formData.append("userId", userId);
    formData.append("moduleId", M_id);
    try {
      const result = await fetchFormData("GetPermissionUser", formData, "POST");

      if (result) {
        const data = result.data || [];
        setData(data);
      }
    } catch (error) {
      console.error("Error fetching initial data:", error);
    } finally {
    }
  };

  const columns = [
    ...(permission?.pf_edit === 1 || permission?.pf_status === 1
      ? [
          {
            accessorKey: "actions",
            header: () => "Actions",
            cell: ({ row }) => {
              const id = row.original.id;
              return (
                <div className="hstack gap-2 justify-content-end">
                  {permission?.pf_edit === 1 && (
                    <span
                      className="cursor-pointer"
                      onClick={() =>
                        navigate(`/employee/edit-employee/${id}?id=${M_id}`)
                      }
                    >
                      <FiEdit3 size={16} />
                    </span>
                  )}
                </div>
              );
            },
            meta: {
              headerClassName: "width-30",
              exportable: false,
            },
          },
        ]
      : []),
    {
      accessorKey: "employ_Id",
      header: () => "Employee ID",
      cell: (info) => info.getValue() || "",
           defaultIsVisible: true,
    },
    {
      accessorKey: "user_name",
      header: () => "User Name",
      cell: (info) => info.getValue() || "",
           defaultIsVisible: true,
    },
    {
      accessorKey: "phone",
      header: () => "Phone Number",
      cell: (info) => info.getValue() || "",
           defaultIsVisible: true,
    },
    {
      accessorKey: "branch_names",
      header: () => "Branch",
      cell: (info) => info.getValue() || "",
           defaultIsVisible: true,
    },
    {
      accessorKey: "employee_names",
      header: () => "Employee Name",
      cell: (info) => info.getValue() || "",
           defaultIsVisible: true,
    },
    
   
    {
      accessorKey: "created_at",
      header: () => "Created At",
      cell: (info) =>
        new Date(info.getValue()).toLocaleDateString("en-GB") || "",
           defaultIsVisible: true,
    },
   
  ];

  useEffect(() => {
    fetchtaskData();
  }, []);
  return (
    <>
      <Table data={data} columns={columns} />
    </>
  );
};
export default UserHeirachyTable;
